module.exports = __webpack_public_path__ + "static/vwtext-bolditalic-19dce7eefb78cd2c3231ee437fbf4fcb.woff2";